import styled from 'styled-components';

export const ContainerNcmEmLote = styled.div`
  width: 100%;
  height: 100%;
  padding: 1.25rem;
`;
